export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["ADMIN"] = "admin";
    OrganizationType["CLIENT"] = "client";
    OrganizationType["CONTRACTOR"] = "contractor";
})(OrganizationType || (OrganizationType = {}));
